import { Card, ScrollShadow } from '@nextui-org/react'
import { FC } from 'react'
import { TankChipContainer } from './TankChipContainer'
import { useBatchStore } from '../../store/batch/useBatchStore'

export type TankModelContentProps = {
  batchIds: string[]
}

export const TankModalContent: FC<TankModelContentProps> = ({ batchIds }) => {
  const batches = useBatchStore((state) => state.batches)

  return (
    <Card
      className="my-2 rounded-lg bg-tdplbisque min-h-fit max-h-[50dvh] p-[0.75rem] border-tdpldarkgrey border-opacity-60 border-1"
      shadow="none"
      data-testid="tank-modal-content"
      role="dialog"
      aria-label="Tank selection modal"
    >
      <ScrollShadow className="w-full h-fit" data-testid="tank-selection-scroll-area">
        {batchIds.map((batchId) => {
          if (batchId !== '$empty' && batchId !== '$unbatched')
            return (
              <TankChipContainer
                key={batchId}
                title={batches[batchId].batchName}
                batchId={batchId}
              />
            )
          else return null
        })}
        {batchIds.includes('$unbatched') ? (
          <TankChipContainer title="Unbatched Tanks" batchId={'$unbatched'} />
        ) : null}
        {batchIds.includes('$empty') ? (
          <TankChipContainer title="Empty Tanks" batchId={'$empty'} />
        ) : null}
      </ScrollShadow>
    </Card>
  )
}
